<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-27 00:50:40
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 02:02:41
-->
<template>
  <div class="dispatchUnreciveOrder">
    <div class="list">
      <van-pull-refresh
        v-model="refreshing"
        success-text="刷新成功"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <businessItem
            v-for="(item, index) in tableList"
            :key="index"
            :info="item"
          ></businessItem>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { repair } from "@/utils/network/interface";
import businessItem from "./item";
export default {
  name: "dispatchUnreciveOrder",
  components: {
    businessItem,
  },
  props: {
    keyWord: String,
  },
  data() {
    return {
      tableList: [],
      show: false,
      currentRow: {},
      unitList: [],
      currentUnit: {},
      columns: [{ text: "杭州" }, { text: "宁波" }, { text: "温州" }],
      showUnit: false,
      showNotice: false,
      refreshing: false,
      loading: false,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      finished: false,
      chargeBack: {},
      showRefund: false,
    };
  },
  watch: {
    keyWord(newVal, oldVal) {
      this.pageInfo.pageNum = 1;
      this.finished = false;
      this.tableList = [];
    },
  },
  created() {},
  mounted() {},
  methods: {
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.tableList = [];
          this.refreshing = false;
        }
        const { pageSize, pageNum } = this.pageInfo;
        let obj = { state: 1, pageSize, pageNum, searchName: this.keyWord };
        repair(obj)
          .then((res) => {
            if (res.code === 200) {
              this.tableList = this.tableList.concat(res.rows);
              this.pageInfo.pageNum++;
              this.pageInfo.total = res.total;
              this.loading = false;
              if (this.tableList.length >= res.total) {
                this.finished = true;
              }
            } else {
              this.loading = false;
              this.finished = true;
            }
          })
          .catch((err) => {});
      }, 1000);
    },
    getData() {
      let obj = {
        state: 1,
        pageSize: 10,
        pageNum: 1,
        searchName: this.keyWord,
      };
      repair(obj)
        .then((res) => {
          this.refreshing = false;
          this.loading = false;
          if (res.code == 200) {
            this.tableList = res.rows;
            this.pageInfo.pageNum++;
            this.pageInfo.total = res.total;
          }
        })
        .catch((err) => {});
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageInfo.pageNum = 1;
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.dispatchUnreciveOrder {
  .bidPopUp {
    padding: 20px;
    .popUpTitle {
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: left;
      color: #333333;
      line-height: 22px;
      margin-bottom: 10px;
    }
    .pickUnit {
      height: 30px;
      background: #eeeeee;
      border: 1px solid #44b1f9;
      border-radius: 5px;
      line-height: 30px;
      background: url("../../../../assets/accountant/selectDown.png")
        calc(100% - 10px) center no-repeat;
      background-size: 12px 10px;
      margin-bottom: 25px;
      padding-left: 10px;
      padding-right: 25px;
      font-size: 14px;
      p {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .unitButton {
      width: 142px;
      height: 28px;
      background: #44b1f9;
      border-radius: 5px;
      display: block;
      margin: 0 auto;
      border: 1px solid #44b1f9;
    }
  }
  .showRefund {
    width: 320px;
    height: 210px;
    background: #ffffff;
    border-radius: 20px;
    padding: 40px 20px 0;
    line-height: 2;
    font-size: 14px;
    font-family: Source Han Sans CN, Source Han Sans CN-Medium;
    font-weight: 500;
    text-align: left;
    color: #666666;
    .btn {
      width: 142px;
      height: 28px;
      background: #44b1f9;
      border-radius: 5px;
      text-align: center;
      color: #fff;
      line-height: 2;
      margin: 30px auto 0;
    }
  }
}
</style>